module.exports = __webpack_public_path__ + "img/diesel-locomotive-07.543c0ef7.png";